import { render, staticRenderFns } from "./JobPreferencesForm.vue?vue&type=template&id=6c1c770e&"
import script from "./JobPreferencesForm.vue?vue&type=script&lang=js&"
export * from "./JobPreferencesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports